import { EventsAndInvitesViewState } from 'mini-options-store/lib/store/schema/EventsAndInvitesViewState';
import { filterUnchangedCalendarCloudSettings } from 'mini-calendar-cloud-settings/lib/utils/filterUnchangedCalendarCloudSettings';
import { logUsage } from 'owa-analytics';

export const logDatapointsOnSaveEventsAndInvitesOption = (viewState: EventsAndInvitesViewState) => {
    const {
        enableOnlineMeetingsByDefault,
        shouldEventsEndEarly,
        endShortEventsBy,
        endLongEventsBy,
    } = viewState;
    const calendarCloudSettings = {
        enableOnlineMeetingsByDefault,
        shouldEventsEndEarly,
        endShortEventsBy,
        endLongEventsBy,
    };

    const filteredSettings = filterUnchangedCalendarCloudSettings(calendarCloudSettings);

    if (filteredSettings.enableOnlineMeetingsByDefault !== null) {
        logUsage('defaultOnlineMeetingOption', [enableOnlineMeetingsByDefault]);
    }

    if (
        filteredSettings.shouldEventsEndEarly !== null ||
        filteredSettings.endShortEventsBy !== null ||
        filteredSettings.endLongEventsBy !== null
    ) {
        logUsage('speedyMeetingsOption', {
            shouldEventsEndEarly,
            endShortEventsBy,
            endLongEventsBy,
        });
    }
};
